import React from 'react'
import { Column } from 'primereact/column'
import utils, { parseCurrency } from '../utils/index'
import storage from '../services/stoage.service'
import '../index.scss'
import { actions as lancamentoPagamentoActions } from '../pages/lancamentoFinanceiroPagamentos/lancamento-pagamentos.actions'
import { actions as lancamentoVendasActions } from '../pages/lancamentoFinanceiroVendas/lancamento-vendas.actions'
import { actions as lancamentoActions } from '../pages/lancamentoFinanceiro/lancamento.actions'
import _ from 'lodash'
import { actions as taxaActions } from '../pages/taxa/taxa.actions'
import { enums } from '../constants'
import { ConfirmDialog } from '../components/confirmDialog/ConfirmDialog'
import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { PrimeIcons } from 'primereact/api'
import ReajustarLancamentoDialog from './lancamento/form/dialogs/reajustar-lancamento-dialog'
import LtsLookupContaCorrente from '../components/lottus/lts-lookup-conta-corrente'

const getConstasBancarias = ({ empresa }) => {
  const result = []
  const contas = utils.getConfiguracaoContasBancarias(empresa, null)
  if (utils.isArrayNotEmpty(contas)) {
    for (const c of contas) {
      const split = c.split('-')
      result.push({ id: split[0].trim(), value: c })
    }
  }
  return result
}
const getDisplayForm = ({ state, crud }) => {
  let displayForm = {
    pagamento: false,
    parcela: false,
    baixar: false,
    baixarParcelas: false,
    gerarNFSeLote: false,
    fecharPedidos: false,
    reajustarLancamentos: false,
  }
  if (state[crud].displayForm) {
    displayForm = state[crud].displayForm
  }
  return displayForm
}
const getLookupTaxa = ({ state, crud }) => {
  const lookupTaxaBase = {
    records: state.crudTaxaState.records,
    columns: state.crudTaxaState.columnsLookup
      .filter(
        (col) =>
          col.field === 'oid' ||
          col.field === 'valor' ||
          col.field === 'grupoFinanceiro_oid' ||
          col.field === 'grupoFinanceiro_descricao'
      )
      .map((col) => <Column key={col.field} {...col} />),
    first: state.crudTaxaState.index,
    rows: state.crudTaxaState.max,
    totalRecords: state.crudTaxaState.count,
    sortField: state.crudTaxaState.sortField,
    order: state.crudTaxaState.sortOrder,
    editDisabled: true,
  }
  return Object.assign({}, state[crud].lookupTaxa, lookupTaxaBase)
}

const getStateToProps = ({ state, crud }) => {
  const empresa = storage.getCompany()
  let unidades = []
  let unidadesEmpresa = utils.getListIdValuesUnidadeFromEmpresa(empresa)
  unidades = unidades.concat(unidadesEmpresa)
  const currentUnit = storage.getUnit()

  const configFormasPagamento = utils.getConfiguracaoFormasPagamento(empresa, currentUnit)
  const formasPagamentoBasica = utils.getFormasPagamento(enums.FormasPagamentoBasica, configFormasPagamento)
  const isGerarLancamentoSaldo = utils.isGerarLancamentoSaldo(empresa, currentUnit)

  return {
    isCustomRoute: storage.isCustomRoute2(state.appState.appCustomRoutes),
    contasBancarias: getConstasBancarias({ empresa }),
    contasCorrentes: state[crud].contasCorrentes,
    isFormaPagamentoCelescDisponivel: utils.isFormaPagamentoCelescDisponivel(),
    displayForm: getDisplayForm({ state, crud }),
    tiposFiltros: utils.getFilters(storage.getAppLabels('filtros')),
    tiposFiltrosTaxas: utils.getFiltersForEntity(storage.getAppLabels('filtros')),
    booleanFilter: state[crud].booleanFilter,
    booleanTypes: [
      { label: 'TODOS', value: '' },
      { label: 'ENTRADA', value: 1 },
      { label: 'SAÍDA', value: 2 },
    ],
    booleanTypesStatus: [
      { label: 'TODOS', value: '' },
      { label: 'EM ABERTO', value: 1 },
      { label: 'PAGO', value: 3 },
      { label: 'CANCELADO', value: 4 },
    ],
    booleanTypesFormaPagamento: utils.getBooleanOptionsFormaDePagamento(empresa, currentUnit),
    record: state[crud].currentRecord,
    messages: state[crud].messages,
    messagesDialog: storage.getAppLabels('dialogs'),
    showHideColumns: state[crud].showHideColumns,
    columns: state[crud].columns,
    records: state[crud].records,
    isLoadingRecords: state[crud].isLoadingRecords,
    first: state[crud].index,
    rows: state[crud].max,
    totalRecords: state[crud].count,
    sortField: state[crud].sortField,
    order: state[crud].sortOrder,
    selectedFilters: state[crud].selectedFilters,
    filterValues: state[crud].filterValues,
    perfis: state.crudPerfilState.records,
    selectedRecords: state[crud].selectedRecords,
    opcoesUnidades: unidades,
    disableUnit: !!currentUnit,
    lookupTaxa: getLookupTaxa({ state, crud }),
    colunasGridFiltroTaxa: state[crud].colunasGridFiltroTaxa,
    formasPagamentoBasica,
    descontosMultasJuros: state[crud].descontosMultasJuros,
    isGerarLancamentoSaldo,
  }
}

const mapDispatchToProps = ({ dispatch, actions, basePath }) => {
  const monetaryFields = ['valor', 'valorBruto', 'valorPago', 'valorReceber', 'valorRecebido']
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.applyFilter(filterParams))
    },
    changeFilterCalendar: (campo, e) => {
      dispatch(actions.setSelectedFilters(campo.field, e.value))
    },
    changeFilter: (column, e) => {
      const target = e.target
      let campo = column.fieldJoin ? column.fieldJoin : target.name

      // tratamentos para nomes dos filtros enum
      if (['tipoGrupoFinanceiro'].find((field) => field === target.name)) {
        dispatch(actions.setBooleanFilter(target.name, target.value))
      }
      if (['status'].find((field) => field === target.name)) {
        dispatch(actions.setBooleanFilter(target.name, target.value))
      }
      if (['tipoFormaPagamento'].find((field) => field === target.name)) {
        dispatch(actions.setBooleanFilter(target.name, target.value))
      }
      if (monetaryFields.includes(target.name)) {
        const rawValue = target.value
        const isEmptyValue =
          rawValue === null || rawValue === undefined || (typeof rawValue === 'string' && rawValue.trim() === '')
        const newValue = isEmptyValue ? '' : parseCurrency(rawValue)
        dispatch(actions.setSelectedFilters(campo, newValue, column.relacionamento, column.field, 'IGUAL_A'))
      } else {
        dispatch(actions.setSelectedFilters(campo, target.value, column.relacionamento, column.field))
      }
      setTimeout(() => {
        dispatch(actions.executeFilter(`${basePath}/all`))
      }, 400)
    },
    setSelectedRecords: (e) => {
      dispatch(actions.setSelectedRecords(e))
    },
    clearSelectedFilters: () => {
      dispatch(actions.clearSelectedFilters())
    },
    carregarLancamentos: () => {
      dispatch(actions.carregarLancamentos())
    },
    setFiltroAvancado: (filtro) => {
      dispatch(actions.setFiltroAvancado(filtro))
    },
    load: () => dispatch(actions.load()),
    setColumns: (columns) => dispatch(actions.loadColumns(columns)),

    pesquisaAvancada: (state, props) => {
      dispatch(actions.clearSelectedFilters())
      setTimeout(() => {
        // como NAO temos mais o status 'VENCIDO'
        // para tal vamos filtrar lancamento com vencimento anterior a data atual
        // e Status = ABERTO
        const valoresFiltros = props.filterValues
        const filtroVencido = _.get(valoresFiltros, ['vencido', 'valor'])
        if (filtroVencido) {
          let novoFiltro = {
            campo: 'vencimento',
            valor: new Date(),
            tipoFiltro: 'MENOR_QUE',
            chaveComponente: 'vencido',
          }
          dispatch(actions.setFiltroAvancado(novoFiltro))

          let filtroStatusAberto = {
            campo: 'status',
            valor: 1, // aberto
            tipoFiltro: 'IGUAL_A',
          }
          dispatch(actions.setFiltroAvancado(filtroStatusAberto))
        }
        const filtroMarcador = _.get(valoresFiltros, ['marcador', 'valor'])
        if (filtroMarcador && filtroMarcador.oid) {
          let novoFiltro = {
            campo: 'oid',
            tipoFiltro: 'IGUAL_A',
            relacionamento: ['marcadores'],
            valor: filtroMarcador.oid,
            chaveComponente: 'marcador',
          }
          dispatch(actions.setFiltroAvancado(novoFiltro))
        }
        const filtroSemNota = _.get(valoresFiltros, ['semNota', 'valor'])
        if (filtroSemNota) {
          let novoFiltro = {
            campo: 'notas.oid',
            tipoFiltro: 'NULO',
            valor: null,
            chaveComponente: 'notas',
          }
          dispatch(actions.setFiltroAvancado(novoFiltro))
        }

        if (!filtroSemNota) {
          const filtroNFSe = _.get(valoresFiltros, ['nfse', 'valor'])
          if (filtroNFSe && filtroNFSe.oid) {
            const novoFiltro = {
              campo: 'notas.oid',
              tipoFiltro: 'IGUAL_A',
              valor: filtroNFSe.oid,
              chaveComponente: 'notas',
            }
            dispatch(actions.setFiltroAvancado(novoFiltro))
          }
        }

        const filtroContaCorrente = _.get(valoresFiltros, ['contaCorrente', 'valor'])
        if (filtroContaCorrente && filtroContaCorrente.oid) {
          let novoFiltro = {
            campo: 'contaCorrente.oid',
            tipoFiltro: 'IGUAL_A',
            valor: filtroContaCorrente.oid,
            chaveComponente: 'contaCorrente',
          }
          dispatch(actions.setFiltroAvancado(novoFiltro))
        }

        const tipoFiltroEmissao = _.get(valoresFiltros, ['emissao', 'tipoFiltro'])
        if (tipoFiltroEmissao && tipoFiltroEmissao?.value !== null) {
          const novoFiltroData = {
            campo: 'emissao',
            valor: _.get(valoresFiltros, ['emissao', 'valor']),
            valorComplementar: _.get(valoresFiltros, ['emissao', 'valorComplementar']),
            tipoFiltro: tipoFiltroEmissao.value,
            chaveComponente: 'emissao',
          }
          dispatch(actions.setFiltroAvancado(novoFiltroData))
        }

        const tipoFiltroVencimento = _.get(valoresFiltros, ['vencimento', 'tipoFiltro'])
        if (tipoFiltroVencimento && tipoFiltroVencimento?.value !== null) {
          const novoFiltro = {
            campo: 'vencimento',
            valor: _.get(valoresFiltros, ['vencimento', 'valor']),
            valorComplementar: _.get(valoresFiltros, ['vencimento', 'valorComplementar']),
            tipoFiltro: tipoFiltroVencimento.value,
            chaveComponente: 'vencimento',
          }
          dispatch(actions.setFiltroAvancado(novoFiltro))
        }

        const tipoFiltroDataPagamento = _.get(valoresFiltros, ['dataPagamento', 'tipoFiltro'])
        if (tipoFiltroDataPagamento && tipoFiltroDataPagamento?.value !== null) {
          const novoFiltro = {
            campo: 'dataPagamento',
            valor: _.get(valoresFiltros, ['dataPagamento', 'valor']),
            valorComplementar: _.get(valoresFiltros, ['dataPagamento', 'valorComplementar']),
            tipoFiltro: tipoFiltroDataPagamento.value,
            chaveComponente: 'dataPagamento',
          }
          dispatch(actions.setFiltroAvancado(novoFiltro))
        }

        const valorFiltroUnidade = _.get(valoresFiltros, ['unidade', 'valor'], [])
        if (utils.isArrayNotEmpty(valorFiltroUnidade)) {
          const filtro = {
            campo: 'unidade',
            valor: valorFiltroUnidade.map((f) => f.id),
            tipoFiltro: 'ESTA_CONTIDO_EM',
            chaveComponente: 'unidade',
          }
          dispatch(actions.setFiltroAvancado(filtro))
        }

        const oidTipo = _.get(valoresFiltros, 'taxa.valor.oidTipo', null)
        if (oidTipo) {
          const novoFiltro = {
            campo: 'oidItemPrincipal',
            valor: oidTipo,
            tipoFiltro: 'IGUAL_A',
          }
          dispatch(actions.setFiltroAvancado(novoFiltro))
        }
        const filtroBoleto = _.get(valoresFiltros, ['boleto', 'valor'])
        if (filtroBoleto) {
          let novoFiltro = {
            campo: 'boleto',
            tipoFiltro: 'NAO_NULO',
            chaveComponente: 'boleto',
          }
          dispatch(actions.setFiltroAvancado(novoFiltro))
        }
        setTimeout(() => {
          dispatch(actions.executeFilter(`${basePath}/all`))
        }, 200)
      }, 250)
    },
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      dispatch(actions.removeErrors([{ field }]))
      dispatch(actions.setField(field, valor))
    },
    showForm(formName, props) {
      dispatch(actions.setDisplayForm(formName, props))
    },
    baixarLancamentos: (parcelas) => dispatch(actions.baixarLancamentosGrid(parcelas)),
    loadFavorito: (menu) => dispatch(actions.loadFavorito(menu)),
    removeFavorito: (menu) => dispatch(actions.removeFavorito(menu)),
    adicionarFavorito: (menu) => dispatch(actions.adicionarFavorito(menu)),
    gerarBoletoLancamento: (lancamento) => dispatch(actions.gerarBoletoLancamento(lancamento)),
    exportarDadosCSV: () => dispatch(actions.exportCSV()),
    salvarState: (state, filters) => dispatch(actions.saveState(state, filters)),
    removerState: (state) => dispatch(actions.removeState(state)),
    clearSelectedRecords: () => dispatch(actions.clearSelectedRecords()),
    addArquivoRetornoBoleto(arquivo, conta, oidContaCorrente, reprocessar) {
      dispatch(actions.processarArquivoRetornoBoleto(arquivo, conta, oidContaCorrente, reprocessar))
    },
    addArquivoRetornoCelesc(arquivo, conta) {
      dispatch(actions.processarArquivoRetornoCelesc(arquivo))
    },
    addArquivoRetornoCergral(arquivo, conta) {
      dispatch(actions.processarArquivoRetornoCergral(arquivo))
    },
    addArquivoRetornoDebitoAutomatico(arquivo, conta) {
      dispatch(actions.processarArquivoRetornoDebitoAutomatico(arquivo))
    },
    gerarDebitoAutomatico: (selectedLancamentos) => {
      if (utils.nonNull(selectedLancamentos) && utils.isArrayNotEmpty(selectedLancamentos)) {
        const oidsLancamentos = selectedLancamentos.map((l) => l.oid)
        dispatch(actions.gerarDebitoAutomatico(oidsLancamentos))
      }
    },
    cancelarLancamentos: (lancamentos) => dispatch(actions.cancelarLancamentos(lancamentos)),
    gerarNFSeLote: (lancamentos) => dispatch(actions.gerarNFSeLote(lancamentos)),

    lookupNotaFiscalServicoSetVisible: (visible) => dispatch(actions.setLookupNotaFiscalServicoVisible(visible)),
    lookupTaxaSetVisible: (visible) => dispatch(actions.setLookupTaxaVisible(visible)),
    lookupTaxaPaginate: (paginationParams, oidUnidade) => {
      dispatch(taxaActions.loadTaxasValidas(paginationParams, oidUnidade))
    },
    lookupTaxaSortOrder: (paginationParams, oidUnidade) =>
      dispatch(taxaActions.loadTaxasValidas(paginationParams, oidUnidade)),
    lookupTaxaApplyFilter: (filterParams, oidUnidade) => {
      dispatch(taxaActions.setFiltroAvancado(filterParams))
      dispatch(taxaActions.loadTaxasValidas(null, oidUnidade))
    },
    lookupTaxaLoad: (oidUnidade) => dispatch(taxaActions.loadTaxasValidas(null, oidUnidade)),
    resetFiltroLookupTaxa: () => {
      dispatch(taxaActions.setFiltroAvancado({}))
      dispatch(actions.clearSelectedFilters())
    },
    getTemplateImportacao: (customPathSuffix = null) => {
      dispatch(actions.getTemplateImportacao(customPathSuffix))
    },
    uploadCsvImportacao: (arquivo, customPathSuffix = null) => {
      dispatch(actions.uploadCsvImportacao(arquivo, customPathSuffix))
    },
    loadContasCorrentes: () => dispatch(actions.getContasCorrentes()),
    executarBaixaLancamentos: (params) => dispatch(actions.executarBaixaLancamentos(params)),
    fecharPedidos: (oidsLancamentos) => dispatch(actions.fecharPedidos(oidsLancamentos)),
    reajustarLancamentos: ({ oidsLancamentos, percentual, callbackFn }) =>
      dispatch(actions.reajustarLancamentos({ oidsLancamentos, percentual, callbackFn })),
    getDescontosMultasJuros: (oidsLancamentos) => dispatch(actions.getDescontosMultasJuros(oidsLancamentos)),
  }
}

export function mapStateToPropsLancamentoPagamentos(state) {
  return getStateToProps({ state, crud: 'crudLancamentoPagamentosState' })
}

export function mapStateToPropsLancamentoVendas(state) {
  return getStateToProps({ state, crud: 'crudLancamentoVendasState' })
}

export function mapStateToPropsLancamento(state) {
  return getStateToProps({ state, crud: 'crudLancamentoState' })
}

export function mapDispatchToPropsLancamentoPagamentos(dispatch) {
  return mapDispatchToProps({
    dispatch,
    actions: lancamentoPagamentoActions,
    basePath: '/lottustech/lancamentosfinanceirospagamentos',
  })
}

export function mapDispatchToPropsLancamentoVendas(dispatch) {
  return mapDispatchToProps({
    dispatch,
    actions: lancamentoVendasActions,
    basePath: '/lottustech/lancamentosfinanceirosvendas',
  })
}

export function mapDispatchToPropsLancamento(dispatch) {
  return mapDispatchToProps({ dispatch, actions: lancamentoActions, basePath: '/lottustech/lancamentosfinanceiros' })
}

export function luOnConfirmBaixarLancamentos({
  valor,
  data,
  formaPagamento,
  lancamentos,
  listPageContainer,
  desconto,
  multa,
  juros,
  oidContaCorrente,
}) {
  const oidsLancamentos = lancamentos.map((l) => l.oid)
  const params = {
    oidsLancamentos,
    valor,
    data,
    formaPagamento,
    desconto,
    multa,
    juros,
    oidContaCorrente,
  }
  listPageContainer.props.executarBaixaLancamentos(params)
  listPageContainer.props.showForm('baixarParcelas', false)
}

export function luGetDialogConfirmarFecharPedidos(listPageContainer) {
  if (listPageContainer.state.showConfirmarFecharPedido) {
    const msgKey = 'lancamentofinanceiro.dialog.message.confirmar.fecharPedido'
    return (
      <ConfirmDialog
        visible={listPageContainer.state.showConfirmarFecharPedido}
        content={utils.getMessage(listPageContainer.props.messagesDialog, msgKey)}
        confirm={() => luFecharPedido(listPageContainer)}
        hideDialog={() => luHideDialog(listPageContainer)}
      />
    )
  }
  return null
}

export function luGetDialogConfirmarReajustarLancamento(listPageContainer) {
  if (listPageContainer.state.showConfirmarReajusteLancamento) {
    return (
      <ReajustarLancamentoDialog
        visible={listPageContainer.state.showConfirmarReajusteLancamento}
        onHide={() => luHideDialog(listPageContainer)}
        lancamentosReajustar={listPageContainer.props.selectedRecords || []}
        onConfirm={(e) => luReajustarLancamento({ listPageContainer, data: e })}
        title={utils.getMessage(listPageContainer.props.messages, 'lancamentofinanceiro.label.reajustarLancamento')}
        labelPercentualReajuste={utils.getMessage(
          listPageContainer.props.messages,
          'lancamentofinanceiro.label.percentualReajuste'
        )}
        labelConfirmar={utils.getMessage(listPageContainer.props.messages, 'lancamentofinanceiro.label.confirmar')}
      />
    )
  }
  return null
}

export function luFecharPedido(listPageContainer) {
  const lancamentosSelecionados = listPageContainer.props.selectedRecords || []
  if (!_.isEmpty(lancamentosSelecionados)) {
    const oids = lancamentosSelecionados.map((l) => l.oid)
    listPageContainer.props.fecharPedidos(oids)
  }
}

export function luReajustarLancamento({ listPageContainer, data }) {
  const lancamentos = data.lancamentos
  const percentual = data.valor
  if (_.isEmpty(lancamentos) || percentual === 0) {
    return
  }
  const oidsLancamentos = lancamentos.map((b) => b.oid)
  listPageContainer.props.reajustarLancamentos({
    oidsLancamentos,
    percentual,
    callbackFn: listPageContainer.props.applyFilter,
  })
}

export function luHideDialog(listPageContainer) {
  listPageContainer.setState({ showConfirmarFecharPedido: false })
  listPageContainer.setState({ showConfirmarCancelar: false })
  listPageContainer.setState({ showProcessarArquivoRetorno: false })
  listPageContainer.setState({ showConfirmarGerarNFSeLote: false })
  listPageContainer.setState({ showConfirmarReajusteLancamento: false })
}

function onClickBaixarLancamentos(listPageContainer) {
  const oids = listPageContainer.props.selectedRecords.map((l) => l.oid)
  listPageContainer.props.getDescontosMultasJuros(oids)
  // o Dialog sera exibido no callback de 'actions.getDescontosMultasJuros'
}

export function luGetCustomButtons(listPageContainer) {
  listPageContainer.botoesImportacaoCustomizados = [
    {
      label: utils.getMessage(listPageContainer.props.messages, 'lancamentofinanceiro.label.templateLancamentoTaxaCsv'),
      icon: PrimeIcons.EXTERNAL_LINK,
      command: () => listPageContainer.props.getTemplateImportacao('/taxas/importacao/template'),
    },
    {
      label: utils.getMessage(listPageContainer.props.messages, 'lancamentofinanceiro.label.csvLancamentoTaxa'),
      icon: PrimeIcons.EXTERNAL_LINK,
      command: () => {
        const input = document.createElement('input')
        input.type = 'file'
        input.accept = '.csv,text/csv'
        input.onchange = (event) => {
          listPageContainer.props.uploadCsvImportacao(event, '/taxas/importacao/base64/csv')
        }
        input.click()
      },
    },
  ]

  return (
    <div>
      {listPageContainer.state.permissoes && !listPageContainer.state.permissoes.alterar ? null : (
        <Button
          disabled={!listPageContainer.isLancamentosSelecionados()}
          onClick={(e) => onClickBaixarLancamentos(listPageContainer)}
          label={utils.getMessage(listPageContainer.props.messages, 'lancamentofinanceiro.label.baixar')}
          style={{ marginRight: '.25em' }}
          className="p-button-success"
        />
      )}
      <Button
        disabled={!listPageContainer.isLancamentosSelecionados()}
        onClick={(e) => listPageContainer.props.gerarDebitoAutomatico(this.props.selectedRecords)}
        label={utils.getMessage(listPageContainer.props.messages, 'lancamentofinanceiro.label.debitoAutomatico')}
        style={{ marginRight: '.25em' }}
        className="p-button-success"
      />
      {!listPageContainer.state.ACAO_CANCELAR_LANCAMENTOS ? null : (
        <Button
          disabled={!listPageContainer.isLancamentosSelecionados()}
          onClick={listPageContainer.cancelarLancamentos}
          label={utils.getMessage(listPageContainer.props.messages, 'lancamentofinanceiro.label.cancelar')}
          style={{ marginRight: '.25em' }}
          className="p-button-danger"
        />
      )}
      <Button
        onClick={listPageContainer.processarArquivoRetorno}
        label={utils.getMessage(listPageContainer.props.messages, 'lancamentofinanceiro.label.processarArquivoRetorno')}
        style={{ marginRight: '.25em' }}
        className="p-button-success"
      />
      <Button
        disabled={!listPageContainer.isLancamentosSelecionados()}
        onClick={listPageContainer.gerarNFSeLote}
        label={utils.getMessage(listPageContainer.props.messages, 'lancamentofinanceiro.label.gerarNfse')}
        style={{ marginRight: '.25em' }}
        className="p-button-success"
      />
      {!listPageContainer.state.FECHAR_PEDIDO_STONE ? null : (
        <Button
          onClick={(e) => listPageContainer.setState({ showConfirmarFecharPedido: true })}
          label={utils.getMessage(listPageContainer.props.messages, 'lancamentofinanceiro.label.fecharPedido')}
          style={{ marginRight: '.25em' }}
          className="p-button-danger"
        />
      )}
      {!listPageContainer.state.ACAO_REAJUSTAR_LANCAMENTOS ? null : (
        <Button
          onClick={(e) => listPageContainer.setState({ showConfirmarReajusteLancamento: true })}
          label={utils.getMessage(listPageContainer.props.messages, 'lancamentofinanceiro.label.reajustar')}
          style={{ marginRight: '.25em' }}
          className="p-button-success"
        />
      )}
    </div>
  )
}

export function luGetContaBancaria(listPageContainer) {
  if (listPageContainer.state.tipoImportacao !== 'BOLETO') {
    return null
  }

  if (listPageContainer.props.contasCorrentes.length > 0) {
    return (
      <div style={{ paddingTop: '20px' }}>
        <span className="p-float-label">
          <LtsLookupContaCorrente
            label="Conta Corrente"
            value={_.get(listPageContainer.state.contaCorrente, 'descricao', '')}
            oidRecord={_.get(listPageContainer.state.contaCorrente, 'oid', '')}
            history={listPageContainer.props.history}
            onChange={(contaCorrente) => listPageContainer.setState({ contaCorrente })}
            editHidden={true}
          />
        </span>
      </div>
    )
  }

  return (
    <div style={{ paddingTop: '20px' }}>
      <span className="p-float-label">
        <Dropdown
          disabled={listPageContainer.props.contasBancarias.length === 1}
          autoWidth={false}
          value={listPageContainer.state.contaBancaria}
          options={listPageContainer.props.contasBancarias}
          onChange={listPageContainer.onChangeContas}
          optionLabel="value"
          optionValue={(v) => v}
          dataKey="value"
          name="contas"
          style={{ width: '100%' }}
          inputId="conta_bancaria"
        />
        <label htmlFor="conta_bancaria">Conta</label>
      </span>
    </div>
  )
}
